<div class="flex justify-between items-center mb-3">
  <button type="button" pButton icon="pi pi-times" class="p-button-text p-button-danger" style="float:right"></button>
  <p-select [options]="anios" [(ngModel)]="anioSeleccionado" (onChange)="onAnioChange($event)"
  class="p-button-outlined w-40"></p-select>
</div>

<div class="calendar-header p-3 border-b">
  <h2 class="text-lg font-semibold text-center">
    {{ tituloMes }}
  </h2>
</div>

<div #calendar style="height: 600px;"></div>

<p-dialog header="Gerenciamientos de Viajes Abiertos & Abiertos Vencidos" [(visible)]="showDialog" [modal]="true"
  [style]="{width: '800px'}">
  @if (eventoSeleccionado) {
    <p-table [value]="data">
      <ng-template pTemplate="header">
        <tr>
          <th>ID</th>
          <th>Origen</th>
          <th>Destino</th>
          <th>Conductor</th>
          <th>Autoriza</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.id }}</td>
          <td>{{ row.origen }}</td>
          <td>{{ row.destino }}</td>
          <td>{{ row.conductor }}</td>
          <td>{{ row.autoriza }}</td>
        </tr>
      </ng-template>
    </p-table>
  }
</p-dialog>